import MuiCardMedia from "@material-ui/core/CardMedia";
import React from "react";

function CardMedia(props) {
  return <MuiCardMedia {...props} />;
}
CardMedia.propTypes = MuiCardMedia.propTypes;
export default CardMedia;
